/* Full-screen spinner shown while a page's dynamic content is being fetched from the
backend. Rendered by default on data-driven pages and removed once the data resolves, so
the brief AWS Lambda cold-start delay shows a loading wheel instead of an empty page. */

export default function LoadingWheel() {
    return (
        <div className="loading-wheel-overlay">
            <div className="loading-wheel" />
        </div>
    );
}
